"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.warehouseDetailsFragment = exports.warehouseErrorFragment = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const warehouseAddressFragment = (0, graphql_tag_1.default) `
  fragment WarehouseAddress on Address {
    city
    cityArea
    companyName
    country {
      __typename
      code
      country
    }
    countryArea
    firstName
    id
    lastName
    phone
    postalCode
    streetAddress1
    streetAddress2
  }
`;
const warehouseFragment = (0, graphql_tag_1.default) `
  fragment Warehouse on Warehouse {
    id
    name
  }
`;
const warehouseWithShippingFragment = (0, graphql_tag_1.default) `
  ${warehouseFragment}
  fragment WarehouseWithShipping on Warehouse {
    ...Warehouse
    shippingZones(first: 100) {
      edges {
        node {
          id
          name
          countries {
            code
            country
          }
          name
          default
          shippingMethods {
            id
            name
            channelListings {
              price {
                amount
                currency
              }
              channel {
                slug
              }
            }
          }
        }
      }
    }
  }
`;
exports.warehouseErrorFragment = (0, graphql_tag_1.default) `
  fragment WarehouseError on WarehouseError {
    code
    field
    message
  }
`;
exports.warehouseDetailsFragment = (0, graphql_tag_1.default) `
  ${warehouseAddressFragment}
  ${warehouseWithShippingFragment}
  fragment WarehouseDetails on Warehouse {
    ...WarehouseWithShipping
    address {
      ...WarehouseAddress
    }
    companyName
    localPickupEnabled
    samedayPickupEnabled
    freeShippingEnabled
  }
`;
//# sourceMappingURL=warehouse.js.map